<mat-dialog-content>
    <span class="popuptext" id="myPopup">
      <strong>IMPORTANT INFORMATION</strong>
      <div>
      Freedom Mortgage charges an upfront fee to cover certain costs incurred with the processing of
      your loan application. This may include the cost of ordering the appraisal or a rate lock fee.
      By clicking "Yes" below you acknowledge that you received a copy of the Loan Estimate
      and previously provided your intent to proceed with the transaction. You also authorize
      Freedom Mortgage to order an appraisal and/or lock your interest rate and charge the
      amount entered above to the credit card or debit card number you provided. The billing
      company that manages the payment process on behalf of Freedom Mortgage is
      “Automated Fee Services. Therefore, the name Automated
      Fee Services will appear on your credit card/debit card statement along
      with the customer service contact information for the company.
      Your statement will display "Mortgage Related Fees" as the purpose for the transaction.
      You further understand that:
      <ul>
        <li>This fee may be non-refundable except
          where required under state law;</li>
        <li>You are responsible to pay for the fee
          regardless of the value of your property as determined by the appraiser </li>
        <li>Payment of the fee does not guarantee approval for any particular loan product and
          your loan must undergo a full underwriting review.</li>
      </ul>
      </div>
    </span>

  </mat-dialog-content>
  <div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="" cdkFocusInitial>Ok</button>
</div>